export default class {
  constructor() {
    this.selector = 'section.recommendations .grid';
    this.btn = 'section.recommendations .js-recommendation-btn';
    this.activeClass = 'active';
    this.loadMore = 'section.recommendations .js-load-more';
    this.filter = 'all';
    this.pagination = 0;
    this.excluded = [];
    this.masonrySettings =  {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      horizontalOrder: true,
    };
    this.current = '';
  }

  init() {
    const elements = document.querySelectorAll(this.selector);
    const $btn = $(this.btn);
    const $loadMore = $(this.loadMore);
    const $vm = this;

    if (![...elements].length) {
      return;
    }

    import(/* webpackChunkName: "js/masonry" */ 'masonry-layout').then(Masonry => {
      this.Masonry = Masonry.default;
      [...elements].forEach((item) => {
        // eslint-disable-next-line
        new this.Masonry(item, this.masonrySettings);
      });
    });

    if ($btn) {
      $btn.on({
        click(e) {
          e.preventDefault();
          $vm.current = $(this).closest('section')[0] ? $(this).closest('section')[0].id : '';
          $vm.filter = $(this).data('id');
          $vm.pagination = 0;
          $vm.excluded = [];
          $vm.loadContent();
        }
      });

      $loadMore.on({
        click(e) {
          e.preventDefault();
          $vm.current = $(this).closest('section')[0] ? $(this).closest('section')[0].id : '';
          $vm.excluded = JSON.parse($(this).attr('data-excluded'));
          $vm.loadContent();
        }
      });
    }
  }

  loadContent() {
    const { filter, pagination, excluded } = this;
    const $vm = this;

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        filter,
        pagination,
        excluded,
        action: 'get_recommendations',
      },
      success(response) {
        if (response.success && response.data.length) {
          $(`#${$vm.current} .js-recommendation-btn`).removeClass($vm.activeClass);
          $(`#${$vm.current} .js-recommendation-btn[data-id=${filter}]`).addClass($vm.activeClass);

          const grid = $(`#${$vm.current} .grid`);
          const template = grid.find('.grid-item').first().clone();

          if (excluded.length === 0) {
            $(grid).find('.grid-item').remove();
          }

          [...response.data].forEach((item) => {
            const newItem = template.clone();
            newItem.find('.wysiwyg').html(item.content || '');
            grid.append(newItem);
          });

          // eslint-disable-next-line
          new $vm.Masonry(grid[0], $vm.masonrySettings);

          const loadMore = $(`#${$vm.current} .js-load-more`);
          if (response.postsLeft > 0) {
            loadMore.removeClass('d-none');
          } else {
            loadMore.addClass('d-none');
          }

          const allPosts = excluded.concat([...response.data].map(item => item.id));
          loadMore.attr('data-excluded', JSON.stringify(allPosts));
        }
      }
    });
  }
}

